export default "__VITE_ASSET__Dmez3xRM__"